import { Component } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NotificationCenterPanelComponent } from '../notifications/notification-center/notification-center-panel.component';

@Component({
    selector: 'app-home-page',
    imports: [CommonModule, CdkScrollable, SidebarComponent, RouterOutlet, NotificationCenterPanelComponent],
    templateUrl: './home-page.component.html',
    styleUrl: './home-page.component.scss'
})
export class HomePageComponent {

}
